module.exports = __webpack_public_path__ + "static/media/ball_tras_640_i.f16fd25e.png";